import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const CustomerDetail = Loadable({
  loader: () => import("./CustomerDetail"),
  loading: Loading
})
